import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import TablesHistoryTable from "components/Tables/TablesHistoryTable";

function TablesHistoryPage() {
  return (
    <>
      <Container fluid>
        <Row>
          <Col lg="12" sm="12" md="12">
            <TablesHistoryTable />
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default TablesHistoryPage;
